<template>
  <div class="borderBack">
    <div class="back" @click="clickItem()">
      <div class="itemImgBack">
        <img :src="item.img" class="itemImg" />
        <p v-if="item.source && item.source != ''" class="itemType">
          {{ item.source }}
        </p>
      </div>
      <p class="author">{{ item.subTitle }}</p>
      <p class="itemTitle">{{ item.title }}</p>
      <div class="tagArea">
        <p v-for="label in tagList" :key="label" class="itemTag">
          {{ label }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tagList: [],
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  created() {},
  mounted() {
    if (this.item.articleLable && this.item.articleLable != "") {
      this.tagList = this.item.articleLable
        .split(",")
        .map((item) => item.trim());
    }
  },
  methods: {
    clickItem() {
      this.$emit("clickItem", this.item);
    },
  },
};
</script>
<style lang="scss" scoped>
.borderBack {
  padding: 20px;
  background-color: unset;
}
.back {
  border-radius: 30px;
  border-style: none;
  width: 324px;
  height: 390px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  align-items: center;
  position: relative;
  flex: 0 0 25%;
  // padding: 20px;
  overflow: hidden;
  background-color: #ffffff;
  cursor: pointer;
}
.itemImgBack {
  width: 100%;
  height: 196px;
  position: relative;
}
.itemImg {
  width: 100%;
  height: 100%;
  background-color: unset;
  border-radius: 20px;
  border-style: none;
  position: absolute;
  left: 0px;
  top: 0px;
}
.itemType {
  position: absolute;
  left: 0px;
  bottom: 0px;
  line-height: 14px;
  text-align: center;
  background-color: #000000;
  color: #ffffff;
  font-size: 14px;
  margin: 0px;
  padding: 6px 7px;
}
.author {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
  color: #0c49ef;
  // line-height: 18px;
  text-align: left;
  width: 100%;
  margin: 15px 0px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.itemTitle {
  color: #000000;
  font-size: 18px;
  // line-height: 30px;
  margin: 0px;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  width: 100%;
}
.tagArea {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  position: absolute;
  bottom: 30px;
  left: 20px;
  //   justify-content: flex-start;
}
.itemTag {
  text-align: center;
  color: #000000;
  font-size: 14px;
  line-height: 14px;
  background-color: #f3f5f7;
  margin: 0px 12px 0px 0px;
  padding: 4px 6px;
}
@media screen and (max-width: 768px) {
  .borderBack {
    padding: 20px;
    background-color: unset;
  }
  .back {
    border-radius: 30px;
    border-style: none;
    width: 324px;
    height: 390px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    align-items: center;
    position: relative;
    // flex: 0 0 25%;
    // padding: 20px;
    overflow: hidden;
    background-color: #ffffff;
  }
  .itemImgBack {
    width: 100%;
    height: 196px;
    position: relative;
  }
  .itemImg {
    width: 100%;
    height: 100%;
    background-color: unset;
    border-radius: 20px;
    border-style: none;
    position: absolute;
    left: 0px;
    top: 0px;
  }
  .itemType {
    position: absolute;
    left: 0px;
    bottom: 0px;
    line-height: 14px;
    text-align: center;
    background-color: #000000;
    color: #ffffff;
    font-size: 14px;
    margin: 0px;
    padding: 6px 7px;
  }
  .author {
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    color: #0c49ef;
    // line-height: 18px;
    text-align: left;
    width: 100%;
    margin: 15px 0px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .itemTitle {
    color: #000000;
    font-size: 18px;
    // line-height: 30px;
    margin: 0px;
    text-align: left;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    width: 100%;
  }
  .tagArea {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    position: absolute;
    bottom: 30px;
    left: 20px;
    //   justify-content: flex-start;
  }
  .itemTag {
    text-align: center;
    color: #000000;
    font-size: 14px;
    line-height: 14px;
    background-color: #f3f5f7;
    margin: 0px 12px 0px 0px;
    padding: 4px 6px;
  }
}
</style>
